var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgA(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46.64 50.51",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26.91 50.51v-11.87h1.39l-.5-1.64h-9.08l-.51 1.66h1.52v11.85h-19.73v-11.87h2.93l8.83-26.77h-1.82v-11.87h27.18v11.87h-2.3l8.83 26.77h3v11.87zm-2.6-23.74-1.06-3.22-1.08 3.22z",
    className: "cjd-border",
    fill: "#525a6f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m28.43 49v-8.84h2l-1.53-4.69h-11.32l-1.52 4.69h2.16v8.84h-16.7v-8.84h2.55l9.86-29.81h-2.48v-8.83h24.15v8.83h-2.94l9.86 29.81h2.6v8.84zm-2-20.7-3.2-9.73-3.23 9.72z",
    className: "cjd-stroke",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m41.39 41.68-10.9-32.85h3.6v-5.83h-21.09v5.83h3.1l-10.91 32.85h-2.19v5.79h13.7v-5.79h-2.81l2.56-7.68h13.61l2.57 7.73h-2.63v5.79h13.61v-5.84zm-23.58-11.87 5.48-16.25 5.35 16.25z",
    className: "cjd-fill",
    fill: "#8089a2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA);
export default __webpack_public_path__ + "static/media/a.02c23c6ed63e82e2b19440b8a07eefd6.svg";
export { ForwardRef as ReactComponent };